import { EmptyStateTitle, EmptyStateSubtitle, PinnedMetricsEmptyStateContainer } from './Styled';

export const PinnedMetricsEmptyState = () => {
  return (
    <PinnedMetricsEmptyStateContainer>
      <EmptyStateTitle>No metrics pinned yet.</EmptyStateTitle>
      <EmptyStateSubtitle>Pin metrics here for easy visibility.</EmptyStateSubtitle>
    </PinnedMetricsEmptyStateContainer>
  );
};
